import { observer } from 'mobx-react';
import moment from 'moment';
import { Component } from 'react';
import { Link } from 'react-router-dom';
import { promobannerStore } from '../../store/promobannerStore';
import { DEBOUNCE_TIME, STATUS_FILTER } from 'src/constants/main';
import { SCREENS } from 'src/constants/screens';
import { localeStore } from 'src/mobx/localesStore';
import { TBooleanInNumber } from 'src/types/main';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import Picker from 'src/view/components/Controls/Pickers/Picker/Picker';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';
import SearchInput from 'src/view/components/Controls/SearchInput/SearchInput';
import './style.scss';

enum PROMOBANNER_STATUS_FILTER {
  ACTIVE = 1,
  INACTIVE = 0,
  EXPIRED = 2,
}

@observer
export default class PromobannersHeader extends Component<{}, {}> {
  handleSearch = (name: string) => {
    promobannerStore.setFilters({ name }, false);
  };

  changeStatus = (options: IPickerOption[]) => {
    if (options.length && options[0].value === PROMOBANNER_STATUS_FILTER.EXPIRED) {
      promobannerStore.setFilters({ status: undefined, end_date: moment(Date.now()).unix() }, false);
    } else {
      promobannerStore.setFilters({ status: options.length ? (options[0].value as TBooleanInNumber) : undefined, end_date: undefined }, false);
    }
  };

  get options(): IPickerOption[] {
    return [
      { label: localeStore.t(STATUS_FILTER.ACTIVE), value: PROMOBANNER_STATUS_FILTER.ACTIVE },
      { label: localeStore.t(STATUS_FILTER.INACTIVE), value: PROMOBANNER_STATUS_FILTER.INACTIVE },
      { label: localeStore.t(STATUS_FILTER.EXPIRED), value: PROMOBANNER_STATUS_FILTER.EXPIRED },
    ];
  }

  get selectedOptions(): IPickerOption[] {
    switch (true) {
      case !promobannerStore.filters.status && promobannerStore.filters.status !== 0 && !promobannerStore.filters.end_date:
        return [];
      case promobannerStore.filters.status === PROMOBANNER_STATUS_FILTER.ACTIVE:
        return [this.options[0]];
      case promobannerStore.filters.status === PROMOBANNER_STATUS_FILTER.INACTIVE:
        return [this.options[1]];
      default:
        return [this.options[2]];
    }
  }

  render() {
    return (
      <div className="d-flex flex-row justify-content-between pr-4">
        <div className="d-flex flex-row">
          <SearchInput
            value={promobannerStore.filters.name}
            onChangeText={this.handleSearch}
            loading={promobannerStore.pagination.loading}
            debounceDelay={DEBOUNCE_TIME.MEDIUM}
            withResetIcon
            customPlaceholder
            placeholder="txt_search"
            className="promobanners-header__search-input mr-2"
            inputClassName="px-3 color-dark text-size-16 family-medium"
          />
          <Picker
            options={this.options}
            selectedOptions={this.selectedOptions}
            onSelect={this.changeStatus}
            placeholder={localeStore.t('txt_delivery_status_h')}
            className="mr-2"
            listClassName="full-width"
          />
        </div>
        <Link to={SCREENS.PROMOBANNER_CREATE()}>
          <Button title={localeStore.t('create_promobanner')} loading={promobannerStore.pagination.loading} />
        </Link>
      </div>
    );
  }
}
